import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-toast-message',
  templateUrl: './toast-message.component.html',
  styleUrls: ['./toast-message.component.css'],
})
export class ToastMessageComponent implements OnInit {
  @Input() message = "";
  @Input() class = "";
  showAlert = true;

  constructor() { }

  ngOnInit() {
    let timerId = setTimeout(() => this.showAlert = false, 3000);
  }

}
